import EnumService from '../EnumService'

export default class RespostaBasicaEnumService extends EnumService{

    constructor(){
        super('enumRespostaBasica');
    }
  
  }